


























import { Component, Vue } from 'vue-property-decorator';
import LayoutBasic from '../../layout/basic.vue';
import * as auth from "@/store/authenticate";
import {TokenData} from "@/store/authenticate";
@Component({
    components: {
        // Adding imported widgets here
    },
    name: 'Login'
})
export default class Home extends Vue {
    async created() {
        await this.fetchData();
        this.$emit('update:layout', LayoutBasic);

    }


    async fetchData(this: any){

        if (!this.isEmptyQueryString(this.$route.query.code) && !this.isEmptyQueryString(this.$route.query.state)){
            const requestBody = {
                code: this.$route.query.code,
                state: this.$route.query.state
            };

            const contentHeader =  {
                'Content-Type': 'application/json'
            };

            try {

               // let response = await this.axios.post("http://localhost:50377/clio/authorization", requestBody, contentHeader)
                let response = await this.axios.post("https://api.messagehub.ca/clio/authorization", requestBody, contentHeader)

                let tokenData = JSON.parse(response.data.response).access_token;
                const accessTokenRequestBody = {
                    accessToken: tokenData,
                    useTokenCookie: true,
                    //rememberMe: true
                };
                let tokenRequestData ={
                    method: "POST",
                    url: "/api/auth/clio",
                    data: accessTokenRequestBody,
                    headers: contentHeader
                };
                try {

                    let resp = await this.axios.post("https://api.messagehub.ca/auth/clio", accessTokenRequestBody, contentHeader);
                    //let resp = await this.axios.post("http://localhost:50377/auth/clio", accessTokenRequestBody, contentHeader);
                    let bearerToken = resp.data.bearerToken;
                    await this.axios.post('https://api.messagehub.ca/session-to-token',null, {
                        withCredentials: true,
                        headers:{
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer '+ bearerToken
                        }
                    })

                    window.location.assign('/')
                }
                catch (e) {
                    console.log(e);
                }
            }
            catch (e) {

            }
        }
    }

    private isEmptyQueryString(code: string) {
        return (!code || 0 === code.length);
    }
    async getToken() {
        try {
            let response = await this.axios.get('https://api.messagehub.ca/clio/code?format=json')
            let dataFromCall = response.data;
            let stateProvided = dataFromCall.state;
            let code = dataFromCall.code;
            let path = 'https://app.clio.com/oauth/authorize?response_type=code&redirect_uri=https%3A%2F%2Fapp.messagehub.ca%2Flogin&client_id='+ code + '&state=' +stateProvided;
           // let path = 'https://app.clio.com/oauth/authorize?response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Flogin&client_id='+ code + '&state=' +stateProvided;
            window.location.replace(path);
        }
        catch (e) {
            console.log(e);
        }
    }
}
